module.exports = __webpack_public_path__ + "img/ic_markets_actived.1d003c98.svg";